import React from 'react'
import { format } from 'date-fns'

import { determineStatus, determineType } from './AssignmentUtils'

const AssignmentHeader = ({ assignmentDetails }) =>
  <div className='assignment-header'>
    <div className='assignment-header-row'>
      <span><b>Assignment Number:</b> {assignmentDetails.lin}</span>
      <span><b>Assignment Date:</b> {format(assignmentDetails.assignmentDate, 'MM/dd/yyyy', { awareOfUnicodeTokens: true })}</span>
      <span><b>RLC:</b> {assignmentDetails.rlcCode}</span>
    </div>
    <div className='assignment-header-row'>
      <span><b>Appraisal Type:</b> {determineType(assignmentDetails)}{assignmentDetails.exteriorOnlyAppraisalReport === 'Y' ? '-EXT ONLY' : ''}</span>
      <span><b>Status:</b> {determineStatus(assignmentDetails.dispositionCode)}</span>
      <span><b>Status Date:</b> {format(assignmentDetails.currentDispositionDate, 'MM/dd/yyyy', { awareOfUnicodeTokens: true })}</span>
    </div>
  </div>

export default AssignmentHeader